
    import '/vercel/path0/docs/demo/ant-design.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-ant-design-demo-ant-design"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/ant-design.md?type=demo')
};